
export const ThanksPage = () =>{
  return (
    <>
      <p>thank you!!</p>
    </>
  );
}